var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-app',{attrs:{"id":"app","params":_vm.f7Params}},[_c('f7-statusbar'),_c('f7-view',{staticClass:"ios-edges",attrs:{"url":"/events/0","main":""}}),_c('f7-panel',{attrs:{"right":"","cover":""}},[_c('f7-view',{attrs:{"url":"/listFilter","name":"filter-panel"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }